import { Controller } from "@hotwired/stimulus"

// Customer-picker glue. When the wrapped <select> changes, update the linked
// turbo-frame's src so the server re-renders the recipient address fields
// (empty, populated from a past customer, or hidden when cleared). Server-side
// rendering keeps populate logic in one place and avoids serializing every
// past customer onto the form as JSON.
//
// Values:
//   - frame-id: id of the <turbo-frame> to update
//   - url:      collection URL for the recipient_fields action; the picked
//               select value is appended as customer_id
export default class extends Controller {
  static values = { frameId: String, url: String }

  load(event) {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame) return

    const value = event.target.value || ""
    const separator = this.urlValue.includes("?") ? "&" : "?"
    frame.src = `${this.urlValue}${separator}customer_id=${encodeURIComponent(value)}`
  }
}
